<div class="ltms-attatchment-container">
    <input type="file" [name]="name" multiple="multiple" accept="accept" (change)="onFileSelect($event)"/>
</div>